<div class="as-cart-container" [ngClass]="totalProducts ? '.pos-fixed' : ''">
  <div class="as-cart-header">
    <mat-label
      class="as-roboto-slab as-font-bold as-font-24 as-line-height-normal"
    >
      {{ 'CART.cart' | translate }}
    </mat-label>
    <mat-icon
      svgIcon="ic-close-green"
      class="as-pointer"
      color="black"
      mat-dialog-close
    ></mat-icon>
  </div>
  <div class="as-total-products">
    <div class="as-column">
      <mat-label class="as-font-14 as-font-semibold">
        ({{ totalProducts }}) {{ 'CART.products' | translate }}
      </mat-label>
      <mat-label class="as-font-14 as-font-grey-88">
        {{ 'CART.shipping' | translate }} - {{ shipping | currency : '$' }}
      </mat-label>
    </div>
    <div class="as-column right">
      <mat-label class="as-font-14 as-font-semibold">
        {{ totalToPay | currency : '$' }}
      </mat-label>
    </div>
  </div>
  @if (loadProducts) {
  <div class="spinner as-spinner-green as-row as-justify-center">
    <mat-spinner [diameter]="60"></mat-spinner>
  </div>
  }
  <div [class.as-products-cart]="true">
    @if (totalProducts && !loadProducts) {
    <div>
      @for (product of cartList; track product) {
      <app-product-cart
        [isFromCart]="false"
        [product]="product"
        (adding)="onAddingProduct($event)"
        (set)="onSetProduct($event)"
        (subtracting)="onSubtractingProduct($event)"
      >
      </app-product-cart>
      }
    </div>
    }
  </div>
  @if (totalProducts && !loadProducts) {
  <button
    mat-button
    class="as-check-cart"
    (click)="onNavigate('/carrito')"
    mat-dialog-close
  >
    <mat-label class="as-font-white as-font-12 as-font-bold as-font-underline">
      {{ 'CART.checkCart' | translate }}
    </mat-label>
  </button>
  } @else {
  <div class="as-empty-cart-alert">
    <mat-label class="as-font-10 as-font-white">
      {{ 'CART.noProducts' | translate }}
    </mat-label>
  </div>
  }
  <button
    mat-button
    class="as-checkout"
    [class.as-disabled]="!totalProducts"
    (click)="onNavigate('/carrito/sugerencias')"
    mat-dialog-close
    [disabled]="!totalProducts"
  >
    <mat-label class="as-font as-font-white as-font-14 as-font-semibold">
      {{ 'CART.continuePurchase' | translate }}
    </mat-label>
  </button>
</div>
